import React from "react";
import { Tab } from "@headlessui/react";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const Tabs = ({ tabs }) => {
  return (
    <Tab.Group>
      <Tab.List className="flex space-x-1 rounded-lg bg-slate-200 p-1 overflow-x-auto whitespace-nowrap no-scrollbar">
        {tabs.map((tab) => (
          <Tab
            key={tab.name}
            className={({ selected }) =>
              classNames(
                "w-full rounded-md py-2 px-3 text-sm font-medium leading-5",
                "focus:outline-none focus:ring-2 ring-offset-2 ring-offset-primary ring-white ring-opacity-60",
                selected
                  ? "bg-white shadow text-primary"
                  : "text-slate-600 hover:bg-white/[0.6]"
              )
            }
          >
            {tab.name}
          </Tab>
        ))}
      </Tab.List>
      <Tab.Panels className="mt-4">
        {tabs.map((tab, idx) => (
          <Tab.Panel key={idx} className="focus:outline-none">
            {tab.content}
          </Tab.Panel>
        ))}
      </Tab.Panels>
    </Tab.Group>
  );
};

export default Tabs;
